import { toInstagramEmbedUrl } from '@presentation/components/ui/instagram-reel-embed-url'

interface InstagramReelEmbedProps {
  permalink: string | null | undefined
  title?: string
  className?: string
}

function cx(...classNames: Array<string | false | null | undefined>): string {
  return classNames.filter(Boolean).join(' ')
}

export default function InstagramReelEmbed({
  permalink,
  title = 'Instagram reel player',
  className,
}: InstagramReelEmbedProps) {
  const embedUrl = toInstagramEmbedUrl(permalink)

  if (!embedUrl) {
    return (
      <div
        className={cx(
          'flex min-h-[240px] items-center justify-center rounded-xl border border-border-light bg-border-light/40 p-6 text-center',
          className,
        )}
      >
        <p className="text-sm font-semibold text-text-secondary">
          Reel playback is unavailable for this post.
        </p>
      </div>
    )
  }

  return (
    <div className={cx('mx-auto w-full max-w-[430px]', className)}>
      <div className="relative w-full overflow-hidden rounded-xl border border-border-light bg-card-surface shadow-md">
        <div className="w-full" style={{ aspectRatio: '9 / 16' }}>
          <iframe
            src={embedUrl}
            title={title}
            className="h-full w-full border-0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </div>
    </div>
  )
}
